// import "bootstrap/dist/css/bootstrap.min.css";

const render = () => {
  import("./styles/scss/style.scss").then(() => {
    require("./AppRendered");
  });
};

render();
